{
  "default": {
    "supportButton": {
      "label": "Get Help"
    }
  }
}
